import { Pipe, PipeTransform } from '@angular/core';
import { intervalToDuration } from 'date-fns';

@Pipe({
  name: 'formatMinutesToHumanize',
  standalone: true,
  pure: true,
})
export class FormatMinutesToHumanizePipe implements PipeTransform {

  transform(minutes: number | null | undefined): string {
    const safeMinutes = Number.isFinite(minutes as number) ? Math.max(0, Math.floor(minutes as number)) : 0;
    const totalMs = safeMinutes * 60_000;

    const duration = intervalToDuration({ start: 0, end: totalMs });

    const formatted: string[] = [];
    if (duration.years)   formatted.push(`${duration.years}r`);
    if (duration.months)  formatted.push(`${duration.months}msc`);
    if (duration.days)    formatted.push(`${duration.days}d`);
    if (duration.hours)   formatted.push(`${duration.hours}h`);
    if (duration.minutes) formatted.push(`${duration.minutes}min`);

    return formatted.length ? formatted.join(' ') : '-';
  }

}
